export default "__VITE_ASSET__CZJ_137a__"